<template>
  <div class="container">
    <div class="" style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >内容管理</el-breadcrumb-item>
          <el-breadcrumb-item class="bread" :to="{ path: '/manage/equipment/equipment-list' }">设备管理</el-breadcrumb-item>
          <el-breadcrumb-item >账号绑定</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <!-- 设备分布 -->
    <div class="equipment-distribution">
       <!-- <dv-border-box-12 > -->
       <div style="padding: 6px 0px 6px 0px;">
          <div class="header-common">
            <div class="header-common-left">
              <div class="title">已绑定账号</div>
            </div>
          </div>
          <div class="distribution-list">
            <el-table
              :data="relatedUsers"
              height="200"
              style="width: 100%"
              border
              :cell-style="tableCellStyle"
              :header-cell-style="tableHeaderCellStyle"
              >
               <el-table-column
                  type="index"
                  label="序号">
                </el-table-column>
                <el-table-column
                  prop="username"
                  label="所在分组">
                </el-table-column>
                <el-table-column
                  prop="username"
                  label="账号名">
                </el-table-column>
                <el-table-column
                  prop="nickname"
                  label="用户姓名">
                </el-table-column>
                <el-table-column
                  label="操作">
                  <template slot-scope="scope">
                    <button class="action-button-base" @click="unbindAccount(scope.row.userId)">解绑</button>
                  </template>
                </el-table-column>
              </el-table>
          </div>
       </div>

       <!-- </dv-border-box-12> -->
     </div>

    <div class="equip-add">
      <dv-border-box-12 style="padding: 5px 0px;">
        <div style="padding:1px 6px 0px 6px">
          <div class="header-common">
            <div class="header-common-left">
              <div class="title">设备绑定账号</div>
            </div>
          </div>
          <el-form
            :model="form"
            label-width="100px"
            class="add-form"
            :rules="rules"
            ref="form">
            <el-form-item label="设备UDI" prop="equip_udi" style="margin-top: 36px;" class="error">
              <el-input id="equip_udi" v-model="form.equip_udi" :readonly="true" style="width: 70%;">
              </el-input>
            </el-form-item>
            <el-form-item label="绑定账号" prop="userId" >
              <el-select id="userId" v-model="form.userId" placeholder="请选择"  style="width: 70%;float:left;" @change="salesChange($event)">
                <el-option
                  v-for="item in accounts"
                  :key="item.userId"
                  :label="item.username"
                  :value="item.userId">
                  <span style="float: left">{{item.username}}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.nickname}}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="margin-top: 40px;">
              <el-button type="primary" class="action-button" @click="resetAccount('form')">重置</el-button>
              <el-button type="primary" class="action-button" @click="submitForm('form')">保存</el-button>
            </el-form-item>
          </el-form>

        </div>
      </dv-border-box-12>
    </div>
  </div>
</template>

<script>
  import {areaSingleConversionUtil} from '../../../utils/povince_handle.js'

  export default {
    data() {
      return {
        loading1:false,
        form: {
          id:'',//设备id
          equip_udi: '',
          userId:'',
          username:'',
          nickname:''
        },
        rules: {
          equip_udi: [{ required: true, message: '请填写设备UDI', trigger: 'blur' }],
          userId:[{ required: true, message: '请选择账号', trigger: 'blur' }]
        },
        accounts:[],
        relatedUsers:[],
      }
    },
    methods: {
      tableCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);text-align:center;font-size: 14px;font-weight: 400;color: #FEFEFE;'
      },
      tableHeaderCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);background:#021950;text-align:center;font-size: 15px;font-weight: 400;color: #00FFFF;'
      },
      getEquipDetail(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/equipment/detail';
        const data = {
          "id":this.form.id
        }

        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data){//获取到该设备信息
                var object = obj.data;
                this.form.equip_udi = object.udi;
                this.relatedUsers = obj.data.relatedUsers;
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      // 获取未绑定设备的账号
      getAccountList(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/equipment/relation/accounts';

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){

              this.accounts = obj.data.accounts;
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      getSelectedList(val){
        this.form.provinceCode = val[0];
        this.form.cityCode = val[0] + val[1]

        areaSingleConversionUtil.codeToName(this.form)

      },
      salesChange(val){
        this.form.connect_saler_id = val;
      },
      maintainerChange(val){
        this.form.connect_maintainer_id = val;
      },
      doctorChange(val){
        this.form.connect_doctor_id = val;
      },
      resetAccount(type) {
        this.form.userId = ''
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.bindOneAccount();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      bindOneAccount(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/equipment/relation/add';
        const data = {
          "equipmentId":this.form.id,
          "userId":this.form.userId
        };
        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.$message({
                type:'success',
                message:'绑定成功'
              })
              this.getEquipDetail()
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      unbindAccount(userId){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/equipment/relation/delete';
        const data = {
          'userId':userId,
          'equipmentId':this.form.id,
        }
        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          // alert(JSON.stringify(res))
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.$message({
                type:'success',
                message:'解绑成功'
              })
              this.getEquipDetail()
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          // alert(JSON.stringify(err))
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
    },
    mounted() {
      this.getEquipDetail();
      this.getAccountList()

      // this.placeList = this.$place.province;
    },
    created() {
      this.form.id = this.$route.query.id;
    }
  }
</script>



<style lang="scss" scoped>
  .container {
    height: 100%;
    margin-top: $header-height;

    .bread >>>.el-breadcrumb__inner{
      color: #606266;
      font-weight: 400;
    }

    .header-common{
      width: 100%;
      height: 45px;
      border-radius: 12px 12px 0 0 ;
      background: linear-gradient(-90deg, #001940, #1564BE);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .header-common-left{
        font-size: 20px;
        font-weight: bold;
        color: #FEFEFE;
        margin-left: 21px;
        .title{
          font-size: 20px;
          font-weight: bold;
          color: #FEFEFE;
        }
      }
    }


    .equipment-distribution{
      // margin: 0px 6px 20px 6px;
      margin-bottom: 20px;
      display: flex;
      flex-direction: row;

      .handle-distribution{
        width: 100%;
        min-width: 740px;
        height: 2100px;
        // border: 2px #1A3F81 solid;
        border-radius: 18px;
        padding-right: 20px;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;

        .handle-one{
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;

          .line-left{
            margin-right: 10px;
            display: flex;
            flex-direction: row;
            align-items: center;

            p{
              color: #11FFF1;
              opacity: 0.2;
              font-size: 18;
              font-weight: 400;
            }

            span{
              color: #11FFF1;
              font-size: 18px;
              font-weight: 400;
            }
          }

          .line-middle{
            width: 162px;
            height: 162px;
            border-radius: 18px;
            // border: 2px solid rgba(0, 177, 183, 0.84);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .line-middle-rate{
              font-size: 25px;
              font-family: Helvetica;
              font-weight: bold;
              color: #00DEFF;
              // text-shadow: 0px 10px 10px rgba(1,24,33,0.7);

              background: linear-gradient(0deg, #FF1800 0.1953125%, #D3CC15 99.6337890625%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              margin-bottom: 0;

              span{
                font-size: 56px;
                font-weight: bold;
                background: linear-gradient(180deg, #D3CC15 0%, #FF1800 100%);

                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
            }

            .line-middle-rate-processing{
              font-size: 25px;
              font-family: Helvetica;
              font-weight: bold;
              color: #00DEFF;
              // text-shadow: 0px 10px 10px rgba(1,24,33,0.7);
              background: linear-gradient(0deg, #8033F2 0%, #00CCFF 99.6337890625%);            -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              margin-bottom: 0;

              span{
                font-size: 56px;
                font-weight: bold;
                background: linear-gradient(0deg, #8033F2 0%, #00CCFF 99.6337890625%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
            }

            .line-middle-rate-finish{
              font-size: 25px;
              font-family: Helvetica;
              font-weight: bold;
              color: #00DEFF;
              // text-shadow: 0px 10px 10px rgba(1,24,33,0.7);
              background: linear-gradient(0deg, #00FF54 0.1953125%, #15D3CC 99.6337890625%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              margin-bottom: 0;

              span{
                font-size: 56px;
                font-weight: bold;
                background: linear-gradient(0deg, #00FF54 0.1953125%, #15D3CC 99.6337890625%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
            }



            .line-middle-status{
              font-size: 22px;

              font-weight: bold;
              color: #fff;
              text-shadow: 0px 10px 10px rgba(1,24,33,0.7);
              background: linear-gradient(180deg, #FFFFFF 0%, #47D6FF 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              margin: 0;
            }
          }

          .line-right{
            margin-left: 10px;
            display: flex;
            flex-direction: row;
            align-items: center;

            p{
              color: #11FFF1;
              opacity: 0.2;
              font-size: 18;
              font-weight: 400;
            }

            span{
              color: #11FFF1;
              font-size: 18px;
              font-weight: 400;
            }
          }
        }
      }

      .distribution-list{
        margin-top: 0;
        margin: 0px 0px 0px 0px;
        padding-bottom: 10px;

        .action-button-base{
          width: 89px;
          height: 31px;
          background: #FAFAFA;
          border: 1px solid rgba(0,144,255,0.84);
          border-radius: 20px;
          background-color: #20478D;
          font-size: 14px;
          font-weight: 400;
          color: #00DEFF;
          display: inline-block;
          line-height: 31px;
          text-align: center;
          text-decoration: none;
        }
      }
    }


    .equip-add{
      width: 100%;
      float: left;

      .add-form{
        padding: 25px 5px;

          .distinguish{
            display: flex;
            flex-direction: row;
          }

          .action-button{
            width: 120px;
            height: 40px;
            background: #FAFAFA;
            border: 1px solid rgba(0,144,255,0.84);
            border-radius: 20px;
            background-color: #20478D;
            font-size: 14px;
            font-weight: 400;
            color: #00DEFF;
          }
          .action-button{
            width: 120px;
            height: 40px;
            background: #FAFAFA;
            border: 1px solid rgba(0,144,255,0.84);
            border-radius: 20px;
            background-color: #20478D;
            font-size: 14px;
            font-weight: 400;
            color: #00DEFF;
          }
      }
    }


  }

</style>



// WEBPACK FOOTER //
// src/view/manage/equipment/equipment-bind.vue